import { Injectable, NgModule } from '@angular/core';
import { HttpHeaders, HttpParams, HttpRequest, HttpClient } from '@angular/common/http';
import { last, map, catchError } from 'rxjs/operators';
import { ResourceHandler, ResourceRequestMethod, ResourceResponseBodyType, ResourceModule as ResourceModule$1 } from '@ngx-resource/core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
class ResourceHandlerHttpClient extends ResourceHandler {
    constructor(http) {
        super();
        this.http = http;
    }
    handle(req) {
        const request = this.prepareRequest(req);
        return {
            observable: this.http.request(request)
                .pipe(last(), map((resp) => this.handleResponse(req, resp)), catchError((resp) => {
                throw this.handleResponse(req, resp);
            }))
        };
    }
    prepareRequest(req) {
        let method = 'GET';
        switch (req.method) {
            case ResourceRequestMethod.Get:
                method = 'GET';
                break;
            case ResourceRequestMethod.Post:
                method = 'POST';
                break;
            case ResourceRequestMethod.Put:
                method = 'PUT';
                break;
            case ResourceRequestMethod.Delete:
                method = 'DELETE';
                break;
            case ResourceRequestMethod.Head:
                method = 'HEAD';
                break;
            case ResourceRequestMethod.Options:
                method = 'OPTIONS';
                break;
            case ResourceRequestMethod.Patch:
                method = 'PATCH';
        }
        const init = {
            withCredentials: req.withCredentials
        };
        switch (req.responseBodyType) {
            case ResourceResponseBodyType.Json:
                init.responseType = 'json';
                break;
            case ResourceResponseBodyType.ArrayBuffer:
                init.responseType = 'arraybuffer';
                break;
            case ResourceResponseBodyType.Blob:
                init.responseType = 'blob';
                break;
            default:
                init.responseType = 'text';
        }
        if (req.headers) {
            init.headers = new HttpHeaders(req.headers);
        }
        if (req.query) {
            init.params = new HttpParams({ fromObject: req.query });
        }
        return new HttpRequest(method, req.url || '', req.body, init);
    }
    handleResponse(req, response) {
        const headers = {};
        const keys = response.headers.keys();
        keys.forEach((key) => {
            headers[key] = response.headers.getAll(key);
        });
        return {
            status: response.status,
            body: response.body || response.error,
            headers
        };
    }
}
ResourceHandlerHttpClient.ɵfac = function ResourceHandlerHttpClient_Factory(t) { return new (t || ResourceHandlerHttpClient)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
ResourceHandlerHttpClient.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ResourceHandlerHttpClient, factory: ResourceHandlerHttpClient.ɵfac });
ResourceHandlerHttpClient.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResourceHandlerHttpClient, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class ResourceModule extends ResourceModule$1 {
    /**
     * For root
     */
    static forRoot(config = {}) {
        return ResourceModule$1.forRoot({
            handler: config.handler || { provide: ResourceHandler, useClass: ResourceHandlerHttpClient, deps: [HttpClient] }
        });
    }
    /**
     * For child
     */
    static forChild(config = {}) {
        return ResourceModule$1.forChild({
            handler: config.handler || { provide: ResourceHandler, useClass: ResourceHandlerHttpClient, deps: [HttpClient] }
        });
    }
}
ResourceModule.ɵfac = /*@__PURE__*/ function () { let ɵResourceModule_BaseFactory; return function ResourceModule_Factory(t) { return (ɵResourceModule_BaseFactory || (ɵResourceModule_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(ResourceModule)))(t || ResourceModule); }; }();
ResourceModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ResourceModule });
ResourceModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResourceModule, [{
        type: NgModule
    }], null, null); })();

/*
 * Public API Surface of handler-ngx-http
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ResourceHandlerHttpClient, ResourceModule };

